import src from "IMAGE";
export default { src, width: 282, height: 296, blurWidth: 0, blurHeight: 0};
